require('./style.scss');

export default class BlockedBox {
    constructor(domEl){
        this.dom = domEl
        this.blockedBox = this._createBox();
        this._appendToDom();
        this._timer = null;
    }

    _appendToDom(){
        this.dom.appendChild(this.blockedBox);
    }

    _createBox(){
        let blockedBox = document.createElement('div');
        blockedBox.className = 'blocked-box';
        blockedBox.onmousedown = () => this._showLockTimer();
        blockedBox.ontouchstart = () => this._showLockTimer();
        this._lock = this._addLockBlock()
        blockedBox.appendChild(this._lock);

        return blockedBox;
    }

    _addLockBlock(){
        let div = document.createElement('div');
        div.className = 'lock';
        div.style.display = 'none';

        return div;
    }

    _showLockTimer(){
        if(this._timer) clearTimeout(this._timer);
        this._showLock();
        this._timer = setTimeout(() => this._hideLock(), 1000);
    }

    _hideLock(){
        this._lock.style.display = 'none'
    }

    _showLock(){
        this._lock.style.display = 'block'
    }

    show(){
        this.blockedBox.style.display = 'block';
    }

    hide(){
        this.blockedBox.style.display = 'none';
    }
}